export default "__VITE_ASSET__6eee13d1__"